module.exports = __webpack_public_path__ + "assets/images/0c1daeb8f0ff2d9ea61b3d581810313e.png";